"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chart_control_options_model_1 = require("./chart-control-options.model");
const label_format_1 = require("../../../views/chart/speedometer-chart/shared/label-format");
class SpeedometerChartControlOptions extends chart_control_options_model_1.ChartControlOptions {
    constructor(options) {
        super(options);
        this._scaleRanges = [];
        if (options.lowerBound === null || options.lowerBound === undefined) {
            throw new Error("Lower Bound Value is required.");
        }
        if (options.upperBound === null || options.upperBound === undefined) {
            throw new Error("Upper Bound Value is required.");
        }
        this._lowerBound = options.lowerBound;
        this._upperBound = options.upperBound;
        options.scaleRanges !== undefined && (this._scaleRanges = options.scaleRanges);
        this._labelFormat = (options.labelFormat === null || options.labelFormat === undefined) ? label_format_1.LabelFormat.NUMBER : options.labelFormat;
    }
    set scaleRanges(scaleRanges) {
        this._scaleRanges = scaleRanges;
    }
    get scaleRanges() {
        return this._scaleRanges;
    }
    set lowerBound(lowerBound) {
        this._lowerBound = lowerBound;
    }
    get lowerBound() {
        return this._lowerBound;
    }
    set upperBound(upperBound) {
        this._upperBound = upperBound;
    }
    get upperBound() {
        return this._upperBound;
    }
    get labelFormat() {
        return this._labelFormat;
    }
    set labelFormat(value) {
        this._labelFormat = value;
    }
}
exports.SpeedometerChartControlOptions = SpeedometerChartControlOptions;
//# sourceMappingURL=speedometer-chart-control-options.model.js.map